// DRAWER MENU PRODUCT SLIDER -- START
var swiper = new Swiper('.drawer_products_slider', {
  scrollbar: {
    el: '.dp_swiper-scrollbar-horizontal',
  },
 slidesPerView: 3,
  spaceBetween: 12,
  navigation: {
    nextEl: '.drawer__products_slider .dp_swiper-button-next',
    prevEl: '.drawer__products_slider .dp_swiper-button-prev',
  },
});
// DRAWER MENU PRODUCT SLIDER -- END

//WHEN FILTER PAGE SCROLL DOWN AFTER TOTAL HEIGHT FILTER SCROLL TO ADD CLASS BODY JS START

jQuery(document).ready(function(){
  setTimeout(() => {
    if(jQuery('body').hasClass('sticky_filter')){
      var elementHeight = 0;
      if(jQuery('.collection-grid__wrapper .collection-filter').length>0){
        elementHeight = jQuery('.collection-grid__wrapper .collection-filter').offset().top
      }
      if(elementHeight!=0){
        $(window).scroll(function() {
          var height = $(window).scrollTop();
          if(height > elementHeight) {
            jQuery('body').addClass('filter_pass');
          }else{
            jQuery('body').removeClass('filter_pass');
          }
        });
      }
    }
  }, 1000);
});

//WHEN FILTER PAGE SCROLL DOWN AFTER TOTAL HEIGHT FILTER SCROLL TO ADD CLASS BODY JS END